import { Button } from "components/DesignSystem/Button/Button";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { Padlock } from "components/icons/Padlock";
import { SmallArrowDown } from "components/icons/SmallArrowDown";

type VendorBulkActionsDropdownProps = {
  hasWritePermission: boolean;
  canMerge: boolean;
  canMarkFormRequired: boolean;
  canRequestEmail: boolean;
  isRequestWFormDisabled: boolean;
  onMerge: () => void;
  onMarkFormRequired: () => void;
  onRequestWForm: () => void;
  onRequestEmail: () => void;
  onMarkRelatedParty: () => void;
};

export const VendorBulkActionsDropdown = ({
  hasWritePermission,
  canMerge,
  canMarkFormRequired,
  canRequestEmail,
  isRequestWFormDisabled,
  onMerge,
  onMarkFormRequired,
  onRequestWForm,
  onRequestEmail,
  onMarkRelatedParty,
}: VendorBulkActionsDropdownProps) => {
  const lockedTag = hasWritePermission ? undefined : <Padlock />;

  return (
    <Dropdown.Root>
      <Dropdown.Trigger asChild>
        <Button
          type="button"
          size="small"
          customType="secondary"
          rightIcon={<SmallArrowDown />}
        >
          Actions
        </Button>
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content align="center" side="top">
          {canMerge && (
            <Dropdown.Item
              onClick={onMerge}
              disabled={!hasWritePermission}
              tag={lockedTag}
            >
              Merge
            </Dropdown.Item>
          )}
          {canMarkFormRequired && (
            <Dropdown.Item onClick={onMarkFormRequired}>
              Mark form required
            </Dropdown.Item>
          )}
          <Dropdown.Item
            onClick={onRequestWForm}
            disabled={!hasWritePermission || isRequestWFormDisabled}
            tag={lockedTag}
          >
            Request W form
          </Dropdown.Item>
          {canRequestEmail && (
            <Dropdown.Item onClick={onRequestEmail}>
              Request Email Address
            </Dropdown.Item>
          )}
          <Dropdown.Item
            onClick={onMarkRelatedParty}
            disabled={!hasWritePermission}
            tag={lockedTag}
          >
            Mark as related party
          </Dropdown.Item>
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
};
